import React from 'react';
import { prettyKey } from 'helpers/formatters';

const ShippingInvoice = ({ shippingEstimate }) => {
  if (!shippingEstimate) return null;

  return (
    <article>
      <h3>Shipping Invoice</h3>
      <br />
      <table className="table">
        <tbody>
          <tr>
            <th>Phones Count</th>
            <td>{shippingEstimate['phones_count']}</td>
          </tr>
          <tr>
            <th>Sims Count</th>
            <td>{shippingEstimate['sims_count']}</td>
          </tr>
          <tr>
            <th>ZIP</th>
            <td>{shippingEstimate['zip_code']}</td>
          </tr>
          <tr>
            <th>Price</th>
            <td>&#36;{shippingEstimate['price']}</td>
          </tr>
          <tr>
            <th>Shipping Service</th>
            <td>{prettyKey(shippingEstimate['shipping_service'])}</td>
          </tr>
        </tbody>
      </table>
    </article>
  );
};

export default ShippingInvoice;
